/**
 * Created by zlj on 2020/05/18.
 */

 import {v4}  from 'uuid';

 /**
  * @param {string} fmt
  * @param {date} date
  * @returns {string}
  * 如：YYYY-mm-dd HH:MM表示2019-06-06 19:45
  */
 export function dateFormat(fmt, date) {
   let ret;
   const opt = {
     "Y+": date.getFullYear().toString(), // 年
     "m+": (date.getMonth() + 1).toString(), // 月
     "d+": date.getDate().toString(), // 日
     "H+": date.getHours().toString(), // 时
     "M+": date.getMinutes().toString(), // 分
     "S+": date.getSeconds().toString() // 秒
     // 有其他格式化字符需求可以继续添加，必须转化成字符串
   };
   for (let k in opt) {
     ret = new RegExp("(" + k + ")").exec(fmt);
     if (ret) {
       fmt = fmt.replace(
         ret[1],
         ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
       );
     }
   }
   return fmt;
 }
 
 // 路径中获取参数
 export function GetRequest(value) {
   var url = decodeURI(location.search); //?id="123456"&Name="bicycle"
   var object = {};
   if (url.indexOf("?") != -1) {
     //url中存在问号，也就说有参数。
     var str = url.substr(1); //得到?后面的字符串
     var strs = str.split("&"); //将得到的参数分隔成数组[id="123456",Name="bicycle"];
     for (var i = 0; i < strs.length; i++) {
       object[strs[i].split("=")[0]] = strs[i].split("=")[1];
     }
     return object[value];
   } else {
     return "";
   }
 
 }
 
 export function isNotEmpty(value) {
     return value != null  && value != undefined && value != "";
 }
 export function isEmpty(value) {
     return value == null  || value == undefined  || value.length == 0 || value == "";
 }
 
 export function uuid() {
   return v4().replaceAll('-','')
 }
 
 export default {
   isNotEmpty,dateFormat,isEmpty
 }
 